import { render, staticRenderFns } from "./SupplierLogin.vue?vue&type=template&id=5f59f913&scoped=true"
import script from "./SupplierLogin.vue?vue&type=script&lang=js"
export * from "./SupplierLogin.vue?vue&type=script&lang=js"
import style0 from "./SupplierLogin.vue?vue&type=style&index=0&id=5f59f913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59f913",
  null
  
)

export default component.exports